import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MealRadioGroupComponent } from './meal-radio-group.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [MealRadioGroupComponent],
  imports: [CommonModule, FontAwesomeModule, TranslocoModule],
  exports: [MealRadioGroupComponent]
})
export class MealRadioGroupComponentModule {}
